import styled from "styled-components";
import { theme } from "../../theme";
import { ClockIcon, UsersIcon } from "@heroicons/react/24/outline";
import { Avatar, Divider, Flex, Popover } from "@mantine/core";
import dayjs from "dayjs";
import { useDroppable } from "@dnd-kit/core";
import { deleteEmployeeFromShiftById } from "../../api/shiftAssignmentApi";
import { createNotification } from "../../utils/useNotification";

const CalendarShiftEventWeekly = ({
  event,
  activeTab,
  selectedRole,
  getShiftsForEmployeeAssign,
}: any) => {
  const { isOver, setNodeRef } = useDroppable({
    id: event?.id.toString(),
  });

  const deleteEmployeeFromShift = async ({ shiftId, employeeId }: any) => {
    try {
      const response: any = await deleteEmployeeFromShiftById({
        shiftId,
        employeeId,
      });
      if (response?.success) {
        getShiftsForEmployeeAssign();
        createNotification({
          success: response?.success,
          message: response?.message,
        });
      } else {
        createNotification({
          success: response?.success,
          message: response?.message,
        });
      }
    } catch (err) {}
  };

  const Event = () => {
    return (
      <>
        <Flex align={"center"} gap={4}>
          <ClockIcon className="icon" height={12} />
          <EventTitle className="text">{event?.title}</EventTitle>
          <EventTitle className="text">
            {!dayjs(event?.startTime).isSame(dayjs(event?.endTime), "day") &&
              `(${dayjs(event?.endTime).format("DD/MM/YYYY")})`}
          </EventTitle>
        </Flex>
        <Flex align={"center"} gap={4}>
          <UsersIcon className="icon" height={12} />
          {activeTab === "shift-plan" ? (
            event?.count && <EventTitle>{event?.count}</EventTitle>
          ) : (
            <EventTitle className="text">
              {event?.employees?.length}/{event?.count}
            </EventTitle>
          )}
        </Flex>
      </>
    );
  };

  return (
    <Popover width={500} position="left-start" shadow="md">
      <Popover.Target>
        <EventWrapper ref={setNodeRef} $event={event} $isOver={isOver}>
          <Event />
        </EventWrapper>
      </Popover.Target>
      <Popover.Dropdown>
        <Flex gap={16} direction={"column"}>
          <Flex direction={"column"} gap={12}>
            <ModalTitle>
              {dayjs(event?.startTime).format("dddd, MMMM DD")}
            </ModalTitle>
            <div>{selectedRole?.label}</div>
            <EventWrapper $event={event} $isOver={isOver}>
              <Event />
            </EventWrapper>
          </Flex>
          <Divider />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            {event?.employees?.map((employee: any) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Flex align={"center"} gap={12}>
                  <Avatar bg={"#EEF2FF"} size="44px">
                    <span>{employee?.name[0]}</span>
                  </Avatar>
                  <div>{employee?.name}</div>
                </Flex>
                <DeleteIcon
                  onClick={(e: any) => {
                    deleteEmployeeFromShift({
                      employeeId: employee?.id,
                      shiftId: event?.id,
                    });
                  }}
                >
                  <Avatar
                    className="icon"
                    radius={0}
                    size={24}
                    src={"/assets/deleteEmployeeIcon.png"}
                  />
                </DeleteIcon>
              </div>
            ))}
          </div>
        </Flex>
      </Popover.Dropdown>
    </Popover>
  );
};

export default CalendarShiftEventWeekly;

const EventWrapper = styled.div<{ $event: any; $isOver: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  padding: 4px;
  opacity: ${({ $isOver }) => ($isOver ? "0.7" : "1")};
  background-color: ${({ $event }) =>
    $event?.employees?.length == 0
      ? "#F3F4F6"
      : $event?.employees?.length > 0 &&
        $event?.employees?.length < $event?.count
      ? "#FEF3F2"
      : $event?.employees?.length === $event?.count
      ? "#ECFDF3"
      : "#F3F4F6"};
  border-radius: 4px;
  border-left: 4px solid
    ${({ $event }) =>
      $event?.employees?.length == 0
        ? "#4B5563"
        : $event?.employees?.length > 0 &&
          $event?.employees?.length < $event?.count
        ? "#EE4549"
        : $event?.employees?.length === $event?.count
        ? "#10B981"
        : "#4B5563"};
  .text {
    color: ${({ $event }) =>
      $event?.employees?.length == 0
        ? "#4B5563"
        : $event?.employees?.length > 0 &&
          $event?.employees?.length < $event?.count
        ? "#EE4549"
        : $event?.employees?.length === $event?.count
        ? "#10B981"
        : "#4B5563"};
  }
  .icon {
    color: ${({ $event }) =>
      $event?.employees?.length == 0
        ? "#4B5563"
        : $event?.employees?.length > 0 &&
          $event?.employees?.length < $event?.count
        ? "#EE4549"
        : $event?.employees?.length === $event?.count
        ? "#10B981"
        : "#4B5563"};
  }
`;

const EventTitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${theme.colors.greyscale.gray80};
`;
const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #111827;
`;

const DeleteIcon = styled(Flex)<any>`
  cursor: pointer;
  align-items: center;
  padding: 4px;
  height: max-content;
  border-radius: 6px;
  background: none;
  &:hover {
    background: #fef3f2;
    .icon {
      filter: brightness(0) saturate(100%) invert(36%) sepia(19%)
        saturate(4307%) hue-rotate(326deg) brightness(101%) contrast(97%);
    }
  }
`;
